import type { FC } from "react";
import { IconButton } from "@mui/material";
import type { Theme } from "@mui/material/styles";
import { TrashCanIcon } from "../../icons";
import { CONNECTION_HOVER_ACTION_CLASS } from "./Connection";

type RemoveConnectionButtonProps = {
  onRemove: () => void;
  ariaLabel: string;
};

export const RemoveConnectionButton: FC<RemoveConnectionButtonProps> = ({ onRemove, ariaLabel }) => (
  <IconButton
    aria-label={ariaLabel}
    onClick={e => {
      e.stopPropagation();
      onRemove();
    }}
    className={CONNECTION_HOVER_ACTION_CLASS}
    sx={{ "position": "relative", "&::after": { content: '""', position: "absolute", inset: "-16px" } }}
  >
    <TrashCanIcon color={(theme: Theme) => theme.palette.text.secondary} size={14} />
  </IconButton>
);
